import React from 'react';
import moment from "moment";
import numberFormat from "../../../helpers/numberFormat";

const StandartRacoonTable = () => {
  return (
    <div>

    </div>
  );
};

export default StandartRacoonTable;

export const standartHead = () => {
  return <thead>
  <tr>
    <td>Номер</td>
    <td>Выписан</td>
    <td>Тип</td>
    <td>Итого</td>
  </tr>
  </thead>
}

export const standartBody = (array)=> {
  return <tbody>
  {array.map((u, index) => {
    return (
      <tr key={index}>
        <td>
          {u.airline} {u.ticketNumber}
        </td>
        <td>{moment.utc(u.issueDate).format("DD.MM.YYYY")}</td>
        <td>{u.refund ? "Возврат" : "Инвойс"}</td>
        <td>{numberFormat(u.total)}</td>
      </tr>
    );
  })}
  <tr>
    <td colSpan={3}>
      <b>Итого</b>
    </td>
    <td>
      <b>
        {numberFormat(
          array
            .map(u => u.total)
            .reduce((a, b) => a + b, 0)
        )}
      </b>
    </td>
  </tr>
  </tbody>
}

export const diffTable = (data) =>{

}
